import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/runner/work/ibm-cloudnative-journey/ibm-cloudnative-journey/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h3>{`Cost of conducting a developer-intermediate journey`}</h3>
    <h4>{`Number of Developers:	      200`}</h4>
    <h4>{`Total Cost for 3 months($):  8652.36`}</h4>
    <h4>{`Cost Per Developer($):   	  43.2618`}</h4>
    <h4>{`Cost per Developer/Month($): 14.4206`}</h4>
    <h4></h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Component`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Monthly Cost($)`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Total Cost($)`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Remarks`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`VPC`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`VPC with subnet, floating IP, connection to classic`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`1`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`3`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Openshift`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`3 worker nodes, 16x32 worker node config`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`2116.8`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`6350.4`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Single zone, VPC clutser, OCP entitlements excluded with cloud pak entitlements`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Openshift`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`2 additional worker nodes during workshop`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`210.96`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`210.96`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Scale up during workshop for 3 days`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Sysdig`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Sysdig Monitoring (Assuming 300 containers, 1M API Calls, 1k time series calls per host)`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`180`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`540`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`LogDNA`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`LogDNA, 7 Day Log Search (Assuming 300 GB/Month)`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`300`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`900`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Container Registry`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Standard (Assuming 200 GB pull traffic, 250 GB Storage)`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`28`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`84`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Db2 Service`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Flex Plan (Assuming 1 instance, 4GB RAM and 2 GB Storage, More than 5 Concurrent Users)`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`189`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`564`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Database Service for the Application Modernization`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Cloud Pak for Applications`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Entitlement from passport advantage`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`0`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`0`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Slack`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Channel for communication during workshop`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`0`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`0`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Github`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Free Tier`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`0`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`0`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      